import { AxiosResponse } from 'axios'

import ClientSDK from '../../../../App/ClientSDK'

import { IRevenueResult } from './IRevenue'

export class Client {
    static getRevenue = (): Promise<IRevenueResult> => {
        return ClientSDK.instance()
            .get(`reports/day-receipts/revenue-past-year`)
            .then(
                (
                    response: AxiosResponse<{ revenues: IRevenueResult }>
                ): IRevenueResult => {
                    return response.data.revenues
                }
            )
    }
}